<template>
  <section class="app-footer">
    <FooterContent></FooterContent>
  </section>
</template>

<script>
  export default {
    name: 'app-footer',
  };
</script>



// WEBPACK FOOTER //
// src/components/AppFooter.vue